import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientListComponent } from './client-list/client-list.component';
import { ClientDetailComponent } from './client-detail/client-detail.component';
import { AuthGuard } from '../auth/auth.guard';
import { ClientDetailUsersComponent } from './client-detail/client-detail-users/client-detail-users.component';
import { ClientDetailMainComponent } from './client-detail/client-detail-main/client-detail-main.component';
import { SuperAdminGuard } from '../auth/superadmin.guard';

export const clientsRoutes: Routes = [
  {
    path: 'clients',
    component: ClientListComponent,
    canActivate: [AuthGuard, SuperAdminGuard],
    data: {
      title: 'Kunder'
    }
  },
  {
    path: 'clients/:id',
    component: ClientDetailComponent,
    children: [
      {
        path: '',
        component: ClientDetailMainComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'users',
        component: ClientDetailUsersComponent,
        canActivate: [AuthGuard],
      }]
  }
];

@NgModule({
  imports: [
    //RouterModule.forChild(projectsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ClientRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/clients/clients-routing.module.ts